<template>
    <div class="guide-back">
        <div class="guide-box">
            <div class="guide-img-box">
                <img :src="imgSrc" class="guide-img">
            </div>

            <div class="operation-nox">
                <el-button type="primary" v-show="guideIndex < guideIndexMax" @click="nextGuide">下一步</el-button>
                <el-button type="primary" v-show="guideIndex >= guideIndexMax" @click="completeGuide">OK</el-button>
                <el-button type="success" @click="completeGuide" v-show="userInfoRef.guideCount > 2">跳過</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, toRef, ref, computed, onMounted} from 'vue'
    import { useUserinfo } from '@/stores/userinfo'

    const emits = defineEmits(['guide-complete'])
    // const props = defineProps(['materialObj'])

    const userinfo = useUserinfo()
    const userInfoRef = toRef(userinfo)

    let { proxy } = getCurrentInstance();

    //當前進行到第幾步指引
    const guideIndex = ref(1)
    //一共幾部指引
    const guideIndexMax = ref(2)

    const imgSrc = computed(() => {
        return `${process.env.BASE_URL}guide_part${guideIndex.value}.png`
    })

    function nextGuide() {
        guideIndex.value += 1
    }

    function completeGuide() {
        emits("guide-complete")
    }

    onMounted(()=>{
        userInfoRef.value.guideCount += 1
    })

</script>

<style scoped>
    .guide-back {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #00000050;
        display: flex;
        left: 0;
        top: 0;
        align-items: center;
        justify-content: center;
    }

    @media screen and (min-width: 520px) {
        .guide-back .guide-box {
            width: 80vmin;
            height: 80vmin;
            background: #fefefe;
        }
    }

    @media screen and (max-width: 520px) {
        .guide-back .guide-box {
            width: 80vmin;
            height: 80vmin;
            background: #fefefe;
        }
    }

    .guide-img-box {
        width: 100%;
        height: calc(100% - 50px);
        text-align: center;
    }

    .guide-img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
    }

    .operation-nox {
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
    }
</style>